import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import usePageSeo from '@/hooks/usePageSeo';
import { animeList } from '@/mocks/anime';
import CategoryLayout, { type CategoryTab } from '../components/CategoryLayout';

const tabs: CategoryTab[] = [
  { key: 'all', label: '全部' },
  { key: '搞笑', label: '轻松搞笑' },
  { key: '轻松', label: '悠然日常' },
  { key: '萌系', label: '软萌治愈' },
];

const title = '日常番合集';
const description =
  '牛奶动漫库日常番合集收录轻松搞笑的校园日常、悠然慢节奏的乡村生活与软萌治愈的萌系动画，适合通勤、睡前随时放松观看。';

export default function Daily() {
  const items = animeList.filter((a) => a.category === 'daily' || a.category === 'moe');

  usePageSeo({
    title: `牛奶动漫库${title} - 日常番、搞笑番、萌系动画补番`,
    description,
    keywords: '牛奶动漫库,日常番合集,搞笑动漫,萌系动画,轻松补番',
    canonical: 'https://cartoplist.github.io/category/daily',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `${title} - 牛奶动漫库`,
        url: 'https://cartoplist.github.io/category/daily',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://cartoplist.github.io/' },
          { '@type': 'ListItem', position: 2, name: title, item: 'https://cartoplist.github.io/category/daily' },
        ],
      },
    ],
  });

  return (
    <>
      <Navbar />
      <CategoryLayout
        category="daily"
        eyebrow="日常与萌系补番目录"
        title={title}
        subtitle={description}
        items={items}
        tabs={tabs}
      />
      <Footer />
      <BackToTop />
    </>
  );
}